import React from 'react';
import { NoValue } from '@/Components/Primitives';

import { defaults, usePredefined, useServices } from '../../Data/Services';
import { classNames } from '../../Services/helpers';

const Services = ({ services: listedServices, ul, className }) => {
    const {services, isLoading: ownLoading} = useServices();
    const {predefined, isLoading: catalogueLoading} = usePredefined()

    if (!listedServices) {
        return <NoValue />
    }

    // The last resort is the type itself, and a custom type is only ever named by
    // the business's own services — so until both reads have answered, "nothing
    // names this" is not yet true, and showing it would print a raw id.
    const stillNaming = ownLoading || catalogueLoading;

    const getTitle = (service) => {
        const own = services?.find(s => s.type === service);

        return own?.title
            ?? predefinedTitle(predefined, service)
            ?? defaults.find(s => s.type === service)?.title
            ?? (stillNaming ? null : service);
    };

    const titled = listedServices.map(service => getTitle(service)).filter(title => title !== null);

    if (ul) {
        return <ul className={classNames('list-unstyled mb-0', className)}>
            {titled.map((title, i) => <li key={title + i}>{title}</li>)}
        </ul>
    }

    return <span className={className}>{titled.join(', ')}</span>;
}

/**
 * The catalogue is grouped by category, so the title lives on the service inside
 * it — reading it off the category (which has none) returned undefined for every
 * type a business had not defined itself.
 */
const predefinedTitle = (categories, type) => {
    for (const category of categories ?? []) {
        const match = category.services?.find(s => s.type === type);

        if (match) {
            return match.title;
        }
    }

    return null;
};

const getServiceString = (serviceIds, services) => {
    if (!services || !serviceIds) {
        return '';
    }

    const titles = services.filter(s => serviceIds.includes(s.type)).map(s => s.title);

    return titles.join(', ');
}

export default Services;

export {
    getServiceString
}
